var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoBoanota(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 543.86 176.31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#2e3192;}.cls-2{fill:#fff;}.cls-3{fill:#2e358c;}.cls-4{fill:#ffffff;}.cls-5{fill:#2e3095;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Asset 3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 0.21,
    width: 41.39,
    height: 41.39
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M30.08,19.93a1.19,1.19,0,0,1,.37.88v1.25a1.17,1.17,0,0,1-.37.87,1.2,1.2,0,0,1-.88.38H23.58v5.62a1.23,1.23,0,0,1-.37.88,1.21,1.21,0,0,1-.88.37H21.08a1.26,1.26,0,0,1-1.25-1.25V23.31H14.2A1.28,1.28,0,0,1,13,22.06V20.81a1.23,1.23,0,0,1,.37-.88,1.19,1.19,0,0,1,.88-.37h5.63V13.93a1.19,1.19,0,0,1,.37-.88,1.23,1.23,0,0,1,.88-.37h1.25a1.25,1.25,0,0,1,.88.37,1.23,1.23,0,0,1,.37.88v5.63H29.2A1.19,1.19,0,0,1,30.08,19.93Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 135.01,
    y: 0.21,
    width: 41.39,
    height: 41.39
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M164.26,20.28a1.23,1.23,0,0,1,.37.88v1.25a1.26,1.26,0,0,1-1.25,1.25h-15a1.23,1.23,0,0,1-.88-.37,1.19,1.19,0,0,1-.37-.88V21.16a1.26,1.26,0,0,1,1.25-1.25h15A1.19,1.19,0,0,1,164.26,20.28Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 45.01,
    y: 45.21,
    width: 41.39,
    height: 41.39
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M74.26,65.28a1.23,1.23,0,0,1,.37.88v1.25a1.26,1.26,0,0,1-1.25,1.25h-15a1.23,1.23,0,0,1-.88-.37,1.19,1.19,0,0,1-.37-.88V66.16a1.26,1.26,0,0,1,1.25-1.25h15A1.19,1.19,0,0,1,74.26,65.28Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 45.01,
    y: 45.21,
    width: 41.39,
    height: 41.39
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M74.26,65.28a1.23,1.23,0,0,1,.37.88v1.25a1.26,1.26,0,0,1-1.25,1.25h-15a1.23,1.23,0,0,1-.88-.37,1.19,1.19,0,0,1-.37-.88V66.16a1.26,1.26,0,0,1,1.25-1.25h15A1.19,1.19,0,0,1,74.26,65.28Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 45.01,
    y: 90.21,
    width: 41.39,
    height: 41.39
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M74.26,110.28a1.23,1.23,0,0,1,.37.88v1.25a1.26,1.26,0,0,1-1.25,1.25h-15a1.23,1.23,0,0,1-.88-.37,1.19,1.19,0,0,1-.37-.88v-1.25a1.26,1.26,0,0,1,1.25-1.25h15A1.19,1.19,0,0,1,74.26,110.28Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 135.01,
    y: 90.21,
    width: 41.39,
    height: 41.39
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M164.26,110.28a1.23,1.23,0,0,1,.37.88v1.25a1.26,1.26,0,0,1-1.25,1.25h-15a1.23,1.23,0,0,1-.88-.37,1.19,1.19,0,0,1-.37-.88v-1.25a1.26,1.26,0,0,1,1.25-1.25h15A1.19,1.19,0,0,1,164.26,110.28Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0.01,
    y: 90.21,
    width: 41.39,
    height: 41.39
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M29.26,110.28a1.23,1.23,0,0,1,.37.88v1.25a1.26,1.26,0,0,1-1.25,1.25h-15a1.23,1.23,0,0,1-.88-.37,1.19,1.19,0,0,1-.37-.88v-1.25a1.26,1.26,0,0,1,1.25-1.25h15A1.19,1.19,0,0,1,29.26,110.28Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 90.01,
    y: 45.21,
    width: 41.39,
    height: 41.39
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M119.26,65.28a1.23,1.23,0,0,1,.37.88v1.25a1.26,1.26,0,0,1-1.25,1.25h-15a1.23,1.23,0,0,1-.88-.37,1.19,1.19,0,0,1-.37-.88V66.16a1.26,1.26,0,0,1,1.25-1.25h15A1.19,1.19,0,0,1,119.26,65.28Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 90.01,
    y: 134.69,
    width: 41.39,
    height: 41.39
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M119.26,154.75a1.23,1.23,0,0,1,.37.88v1.25a1.23,1.23,0,0,1-.37.88,1.19,1.19,0,0,1-.88.37h-15a1.26,1.26,0,0,1-1.25-1.25v-1.25a1.19,1.19,0,0,1,.37-.88,1.23,1.23,0,0,1,.88-.37h15A1.23,1.23,0,0,1,119.26,154.75Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 45,
    y: 0.21,
    width: 41.39,
    height: 41.39
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M75.08,19.93a1.19,1.19,0,0,1,.37.88v1.25a1.17,1.17,0,0,1-.37.87,1.2,1.2,0,0,1-.88.38H68.58v5.62a1.23,1.23,0,0,1-.37.88,1.21,1.21,0,0,1-.88.37H66.08a1.26,1.26,0,0,1-1.25-1.25V23.31H59.2A1.28,1.28,0,0,1,58,22.06V20.81a1.23,1.23,0,0,1,.37-.88,1.19,1.19,0,0,1,.88-.37h5.63V13.93a1.19,1.19,0,0,1,.37-.88,1.23,1.23,0,0,1,.88-.37h1.25a1.25,1.25,0,0,1,.88.37,1.23,1.23,0,0,1,.37.88v5.63H74.2A1.19,1.19,0,0,1,75.08,19.93Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 134.69,
    width: 41.39,
    height: 41.39
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M30.08,154.4a1.19,1.19,0,0,1,.37.88v1.25a1.26,1.26,0,0,1-1.25,1.25H23.58v5.63a1.26,1.26,0,0,1-1.25,1.25H21.08a1.23,1.23,0,0,1-.88-.37,1.21,1.21,0,0,1-.37-.88v-5.63H14.2a1.19,1.19,0,0,1-.88-.37,1.23,1.23,0,0,1-.37-.88v-1.25A1.26,1.26,0,0,1,14.2,154h5.63v-5.62a1.26,1.26,0,0,1,1.25-1.25h1.25a1.21,1.21,0,0,1,.88.37,1.23,1.23,0,0,1,.37.88V154H29.2A1.23,1.23,0,0,1,30.08,154.4Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 45,
    y: 134.69,
    width: 41.39,
    height: 41.39
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M75.08,154.4a1.19,1.19,0,0,1,.37.88v1.25a1.26,1.26,0,0,1-1.25,1.25H68.58v5.63a1.26,1.26,0,0,1-1.25,1.25H66.08a1.23,1.23,0,0,1-.88-.37,1.21,1.21,0,0,1-.37-.88v-5.63H59.2a1.19,1.19,0,0,1-.88-.37,1.23,1.23,0,0,1-.37-.88v-1.25A1.26,1.26,0,0,1,59.2,154h5.63v-5.62a1.26,1.26,0,0,1,1.25-1.25h1.25a1.21,1.21,0,0,1,.88.37,1.23,1.23,0,0,1,.37.88V154H74.2A1.23,1.23,0,0,1,75.08,154.4Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 90,
    y: 0.21,
    width: 41.39,
    height: 41.39
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M120.08,19.93a1.19,1.19,0,0,1,.37.88v1.25a1.17,1.17,0,0,1-.37.87,1.2,1.2,0,0,1-.88.38h-5.62v5.62a1.23,1.23,0,0,1-.37.88,1.21,1.21,0,0,1-.88.37h-1.25a1.26,1.26,0,0,1-1.25-1.25V23.31H104.2A1.28,1.28,0,0,1,103,22.06V20.81a1.23,1.23,0,0,1,.37-.88,1.19,1.19,0,0,1,.88-.37h5.63V13.93a1.19,1.19,0,0,1,.37-.88,1.23,1.23,0,0,1,.88-.37h1.25a1.25,1.25,0,0,1,.88.37,1.23,1.23,0,0,1,.37.88v5.63h5.62A1.19,1.19,0,0,1,120.08,19.93Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 135,
    y: 45.69,
    width: 41.39,
    height: 41.39
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M165.08,65.4a1.19,1.19,0,0,1,.37.88v1.25a1.26,1.26,0,0,1-1.25,1.25h-5.62v5.63a1.26,1.26,0,0,1-1.25,1.25h-1.25a1.23,1.23,0,0,1-.88-.37,1.21,1.21,0,0,1-.37-.88V68.78H149.2a1.19,1.19,0,0,1-.88-.37,1.23,1.23,0,0,1-.37-.88V66.28A1.26,1.26,0,0,1,149.2,65h5.63V59.41a1.26,1.26,0,0,1,1.25-1.25h1.25a1.21,1.21,0,0,1,.88.37,1.23,1.23,0,0,1,.37.88V65h5.62A1.23,1.23,0,0,1,165.08,65.4Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 135,
    y: 134.69,
    width: 41.39,
    height: 41.39
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M165.08,154.4a1.19,1.19,0,0,1,.37.88v1.25a1.26,1.26,0,0,1-1.25,1.25h-5.62v5.63a1.26,1.26,0,0,1-1.25,1.25h-1.25a1.23,1.23,0,0,1-.88-.37,1.21,1.21,0,0,1-.37-.88v-5.63H149.2a1.19,1.19,0,0,1-.88-.37,1.23,1.23,0,0,1-.37-.88v-1.25A1.26,1.26,0,0,1,149.2,154h5.63v-5.62a1.26,1.26,0,0,1,1.25-1.25h1.25a1.21,1.21,0,0,1,.88.37,1.23,1.23,0,0,1,.37.88V154h5.62A1.23,1.23,0,0,1,165.08,154.4Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 90,
    y: 89.69,
    width: 41.39,
    height: 41.39
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M120.08,109.4a1.19,1.19,0,0,1,.37.88v1.25a1.26,1.26,0,0,1-1.25,1.25h-5.62v5.63a1.26,1.26,0,0,1-1.25,1.25h-1.25a1.23,1.23,0,0,1-.88-.37,1.21,1.21,0,0,1-.37-.88v-5.63H104.2a1.19,1.19,0,0,1-.88-.37,1.23,1.23,0,0,1-.37-.88v-1.25A1.26,1.26,0,0,1,104.2,109h5.63v-5.62a1.26,1.26,0,0,1,1.25-1.25h1.25a1.21,1.21,0,0,1,.88.37,1.23,1.23,0,0,1,.37.88V109h5.62A1.23,1.23,0,0,1,120.08,109.4Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 44.69,
    width: 41.39,
    height: 41.39
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M30.08,64.4a1.19,1.19,0,0,1,.37.88v1.25a1.26,1.26,0,0,1-1.25,1.25H23.58v5.63a1.26,1.26,0,0,1-1.25,1.25H21.08a1.23,1.23,0,0,1-.88-.37,1.21,1.21,0,0,1-.37-.88V67.78H14.2a1.19,1.19,0,0,1-.88-.37,1.23,1.23,0,0,1-.37-.88V65.28A1.26,1.26,0,0,1,14.2,64h5.63V58.41a1.26,1.26,0,0,1,1.25-1.25h1.25a1.21,1.21,0,0,1,.88.37,1.23,1.23,0,0,1,.37.88V64H29.2A1.23,1.23,0,0,1,30.08,64.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M303.57,55.62a26,26,0,0,1-26,26H222V0h51.42a22.09,22.09,0,0,1,22,22,21.63,21.63,0,0,1-3.49,11.89A26,26,0,0,1,303.57,55.62Zm-67-26.11h37a7.47,7.47,0,0,0,0-14.93h-37Zm41,37.42a11.43,11.43,0,0,0,0-22.85h-41v23h41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M391,40.82A40.81,40.81,0,1,1,350.21,0,40.84,40.84,0,0,1,391,40.82Zm-14.57,0a26.23,26.23,0,1,0-26.23,26.23A26.27,26.27,0,0,0,376.44,40.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M468.2,81.62H451.87l-7.46-14.57-17.84-35-17.83,35-7.47,14.57H385l7.46-14.57L426.57,0l34.16,67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M303.57,94.7v81.61L289,165.12l-52.46-40.46v51.65H222V94.93l14.58,11.2L289,146.58v-52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M393.93,135.39a40.81,40.81,0,1,1-40.81-40.81A40.86,40.86,0,0,1,393.93,135.39Zm-14.58,0a26.23,26.23,0,1,0-26.23,26.23A26.26,26.26,0,0,0,379.35,135.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M476.47,94.7v14.57H443v67H428.44v-67H395V94.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M543.86,176.2H527.54l-7.47-14.58-17.83-35-17.84,35-7.46,14.58H460.61l7.47-14.58,34.16-67,34.16,67Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 193.89,
    y: 0.01,
    width: 6,
    height: 175.15,
    transform: "translate(-0.32 0.72) rotate(-0.21)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M120.08,19.93a1.19,1.19,0,0,1,.37.88v1.25a1.17,1.17,0,0,1-.37.87,1.2,1.2,0,0,1-.88.38h-5.62v5.62a1.23,1.23,0,0,1-.37.88,1.21,1.21,0,0,1-.88.37h-1.25a1.26,1.26,0,0,1-1.25-1.25V23.31H104.2A1.28,1.28,0,0,1,103,22.06V20.81a1.23,1.23,0,0,1,.37-.88,1.19,1.19,0,0,1,.88-.37h5.63V13.93a1.19,1.19,0,0,1,.37-.88,1.23,1.23,0,0,1,.88-.37h1.25a1.25,1.25,0,0,1,.88.37,1.23,1.23,0,0,1,.37.88v5.63h5.62A1.19,1.19,0,0,1,120.08,19.93Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBoanota);
export default __webpack_public_path__ + "static/media/logo-boanota.7c63123c3e1d701057d5d282aa4f4e41.svg";
export { ForwardRef as ReactComponent };